import { useCallback } from 'react';
import { captureException } from '../utils/sentryUtils';
import { assertApprovalDataResolved } from '../utils/assertApprovalDataResolved';
import { toApprovalData } from '../utils/approvalResponseAdapters';
import { useRejectApprovalStepMutation } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import { GET_LATEST_APPROVAL_QUERY } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.dfc.new';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
export const useRejectApprovalStep = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  usersRecord,
  agentsRecord,
  teamsRecord,
  resolvedData
}) => {
  const [rejectApprovalStepMutation] = useRejectApprovalStepMutation();
  const rejectStep = useCallback((approvalStepId, rejectionNote) => {
    const validated = assertApprovalDataResolved('useRejectApprovalStep', resolvedData, approvableObjectId);
    return rejectApprovalStepMutation({
      variables: {
        approvalStepId,
        rejectionNote
      },
      update: (cache, {
        data: mutationData
      }) => {
        var _mutationData$result;
        const approvalData = mutationData === null || mutationData === void 0 || (_mutationData$result = mutationData.result) === null || _mutationData$result === void 0 ? void 0 : _mutationData$result.approval;
        if (approvalData) {
          cache.writeQuery({
            query: GET_LATEST_APPROVAL_QUERY,
            variables: {
              approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
              approvalAction,
              approvableObjectId: validated.approvableObjectId
            },
            data: {
              result: {
                approval: approvalData
              }
            }
          });
        }
      }
    }).then(result => {
      var _result$data;
      const approval = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.result) === null || _result$data === void 0 ? void 0 : _result$data.approval;
      if (approval) {
        return toApprovalData(approval, usersRecord, agentsRecord, approvalType, approvalAction, teamsRecord);
      } else {
        throw new Error('rejectApprovalStep succeeded but returned no approval data');
      }
    }).catch(error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalData-rejectStep',
          approvalType,
          approvalAction,
          approvalStepId
        }
      });
      throw error;
    });
  }, [rejectApprovalStepMutation, resolvedData, usersRecord, agentsRecord, teamsRecord, approvalType, approvalAction, approvableObjectId]);
  return rejectStep;
};